import { render, staticRenderFns } from "./ConfigureItem.vue?vue&type=template&id=e6bee58c&scoped=true"
import script from "./ConfigureItem.vue?vue&type=script&lang=js"
export * from "./ConfigureItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bee58c",
  null
  
)

export default component.exports